const rows = [
  {
    requirement: "Keep records of temperature control",
    inApp: "Temperature logs — fridge, freezer, hot-hold, cold-hold",
  },
  {
    requirement: "Record what went wrong and what you did about it",
    inApp: "Deviations and corrective actions",
  },
  {
    requirement: "Document cleaning and hygiene routines",
    inApp: "Cleaning and hygiene checks",
  },
  {
    requirement: "Be able to show an inspector it was done",
    inApp: "Exportable history — PDF and CSV with timestamps",
  },
];

const RegulationMap = () => (
  <section id="regulations" className="relative">
    <div className="max-w-5xl mx-auto px-4 py-16 md:py-24">
      <h2 className="heading-section text-white mb-4 text-center">
        What the rules require, and where the app does it
      </h2>
      <p className="text-white/70 text-center max-w-2xl mx-auto mb-10">
        Crystal HACCP is software, not a certification. These are the record-keeping
        duties the regulations place on you, and the screens that cover them.
      </p>

      <div className="glass-panel rounded-3xl overflow-hidden">
        <div className="hidden md:grid grid-cols-2 border-b border-white/10 text-sm uppercase tracking-wide text-white/50">
          <div className="p-4">Requirement</div>
          <div className="p-4 border-l border-white/10">In Crystal HACCP</div>
        </div>
        {rows.map((row) => (
          <div
            key={row.requirement}
            className="grid md:grid-cols-2 border-b border-white/10 last:border-b-0"
          >
            <div className="p-4 text-white/80">{row.requirement}</div>
            <div className="p-4 md:border-l border-white/10 text-white font-medium">
              {row.inApp}
            </div>
          </div>
        ))}
      </div>

      <p className="text-white/60 text-sm mt-6 text-center">
        Norway:{" "}
        <a
          href="https://lovdata.no/dokument/SF/forskrift/1994-12-15-1187"
          target="_blank"
          rel="noreferrer"
          className="underline hover:text-white"
        >
          Forskrift om internkontroll
        </a>{" "}
        and Mattilsynet's five parts — planlegging, organisering, utførelse,
        vedlikehold, dokumentasjon. UK: the FHRS{" "}
        <a
          href="https://www.food.gov.uk/safety-hygiene/food-hygiene-rating-scheme"
          target="_blank"
          rel="noreferrer"
          className="underline hover:text-white"
        >
          Confidence in Management
        </a>{" "}
        score, which is a third of your rating and is about documented procedures.
      </p>
    </div>
  </section>
);

export default RegulationMap;